import { render, staticRenderFns } from "./RatingTypeForm.vue?vue&type=template&id=16d7da4e&"
import script from "./RatingTypeForm.vue?vue&type=script&lang=js&"
export * from "./RatingTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports